import React from "react";
import Header from "../include/Header"
import Contents from "../include/Contents"
import Footer from "../include/Footer"
import PortInfo from "../info/Portinfo"
import WrapTitle from "../include/WrapTitle"
import ContactInfo from "../include/ContactInfo"
import Loader from "../include/Loader"
import axios from 'axios';


class Portfolio extends React.Component {
    state ={
        isLoading : true,
        ports : [],
    }

    getPorts = async () =>{
        //json파일의 데이터 불러오기
        const {
            data: {
                data:{ports},
            },
        } = await axios.get("https://webstoryboy.github.io/react5001/src/assets/json/portfolio.json");
        //console.log(ports);
        // console.log((await ports).data.data.ports);
        this.setState({ports: ports,isLoading:false})
    }


    componentDidMount(){
        // 사이트 업로드 후 3초 뒤에 inLoading 값이 false로 실행된다.
        setTimeout(()=>{
            // this.setState({isLoading : false});
            this.getPorts();
        },2000)
    }

    render(){
        //state에 있는 것 가져오기..?
        const { isLoading , ports } = this.state

        return (
            <div>
                 { isLoading ? (
                    <Loader />
                ) : (
                    <div>
                        <Header/>
                        <Contents>
                            <section id="portCont">
                                <div className="container">
                                    <WrapTitle text={["portfolio","Site"]}/>
                                    <div className="port__cont">
                                        {ports.map((port) => ((
                                            <PortInfo 
                                                id = {port.id}
                                                title = {port.title}
                                                category = {port.category}
                                                link = {port.link}
                                                image = {port.image}
                                                key = {port.id}
                                            />
                                        )))}
                                    </div>
                                </div>
                            </section>
                            <ContactInfo />
                        </Contents>
                        <Footer />
                    </div>
                )}
            </div>
        )
    }
}

export default Portfolio;